import React, {useRef, useEffect} from 'react';

import {AnalysisBoxItemProps} from './AnalysisBoxItem.props';
import './AnalysisBoxItem.styles.css'
import Box from "@mui/material/Box";
import {RadialGraph} from "../../atoms/RadialGraph";
import {Typography, Tooltip} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TooltipBox from "../../atoms/TooltipBox/TooltipBox";
import {ZONE_EXCEPTION} from "../../../constants/contants";
import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";

export const AnalysisBoxItem: React.FC<AnalysisBoxItemProps> = ({
                                                                    payload = {},
                                                                    index = 0
                                                                }) => {
    const entity_score: number = payload.score;
    const entity_value: string = payload.value;
    // Handle for safe link
    const is_safe_link: boolean = typeof payload.data === "object" && payload.data["is_safe_link"]
    const entity_data: string = is_safe_link ? payload.data["entity_meta"] : entity_value;
    const entity_message: string = payload.message;
    const entity_type: string = payload.message;

    const { t } = useTranslation();

    const OverriddenIndicator = () => (
        <TooltipBox tooltip={t('tooltips.inboxDetails.statusSetByExceptionRule')}>
            <Typography fontSize={12} fontWeight={400} color="#000000e6" maxWidth={"250px"}>
                {`[ Status Overridden Via `}
                <Link to={"/settings/threat-exceptions"} className={"exception-list-navigate-link"}>Exception List</Link>
                {` ]`}
            </Typography>
        </TooltipBox>
    );

    return <Box className={'analysis-box-item'}>
        <div className={'analysis-box-top'}>
            <div className={'analysis-box-start'}>
                {
                    is_safe_link ?
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div className={'analysis-box-item-no'} style={{marginTop: "18px"}}>
                                {index}
                            </div>
                            <div>
                                <span style={{fontWeight: 600, marginLeft: "28px", fontSize: "10px"}}>
                                    Original URL:
                                </span>
                                <div className={'analysis-box-item-value'}>
                                    <Tooltip placement={"top"} title={entity_value}>
                                        <div>{entity_value}</div>
                                    </Tooltip>
                                </div>
                            </div>
                            <Tooltip placement={"top"} title={`Rewritten URL: ${entity_data}`}>
                                <InfoOutlinedIcon fontSize={"medium"} sx={{marginLeft: '8px', marginTop: "18px"}} htmlColor={"#193051"}/>
                            </Tooltip>
                        </div>
                        :
                        <div>
                            <div className={'analysis-box-item-no'}>
                                {index}
                            </div>
                            <div className={'analysis-box-item-value'}>
                                <Tooltip placement={"top"} title={entity_value}>
                                    <div>{entity_value}</div>
                                </Tooltip>
                            </div>
                        </div>
                }
                <div style={{paddingLeft: '30px'}}>
                    {payload.content}
                </div>
            </div>
        </div>
        <div>
            <div className={'analysis-box-bottom'}>
                <Typography variant={'body2'} className={'app-label analysis-box-item-message'}>
                    <p dangerouslySetInnerHTML={{__html: entity_message}}></p>
                </Typography>
                {payload?.source === ZONE_EXCEPTION && <OverriddenIndicator/>}
            </div>
        </div>
        <div className={'analysis-box-item-score'}>
            <RadialGraph chartLayoutPosition={{left: 20}} chartStyle={{stroke: 'unset'}} isToolTipHover={true}
                         value={entity_score}/>
        </div>
        <div className={'under-line'}></div>
    </Box>;
};
